import React, { createRef, RefObject } from 'react';
import { UncontrolledTooltip } from 'reactstrap';

type DateFormatProps = {
  date: string;
};

export const DateFormat = ({ date }: DateFormatProps) => {
  const formatted = (zone?: string) =>
    new Intl.DateTimeFormat(zone, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(Date.parse(date));

  return <span style={{ whiteSpace: 'nowrap' }}>{formatted('sv-SE')}</span>;
};

type DateTimeFormatProps = {
  dateTime: string;
  dateStyle?: 'short' | 'full' | 'long' | 'medium';
  timeStyle?: 'short' | 'full' | 'long' | 'medium';
  tooltip?: boolean;
};

export const DateTimeFormat = ({
  dateTime,
  dateStyle = 'short',
  timeStyle = 'medium',
  tooltip,
}: DateTimeFormatProps) => {
  const formatted = (zone?: string, options?: Intl.DateTimeFormatOptions) =>
    new Intl.DateTimeFormat(zone, options).format(Date.parse(dateTime));
  const ref = tooltip ? createRef<HTMLElement>() : undefined;
  return (
    <>
      <span ref={ref} style={{ whiteSpace: 'nowrap' }}>
        {formatted('sv-SE', { dateStyle, timeStyle })}
      </span>
      {tooltip && (
        <UncontrolledTooltip
          target={ref as RefObject<HTMLElement>}
          placement="bottom"
          style={{ maxWidth: 'none', whiteSpace: 'nowrap' }}
        >
          {formatted(undefined, { dateStyle: 'long', timeStyle: 'long' })}
        </UncontrolledTooltip>
      )}
    </>
  );
};

type LocalDateFormatProps = {
  date: string;
};

export const LocalDateFormat = ({ date }: LocalDateFormatProps) => <span style={{ whiteSpace: 'nowrap' }}>{date}</span>;
